import {
  configApiRef,
  useApi,
  microsoftAuthApiRef,
} from '@backstage/core-plugin-api';
import { useCallback, useEffect, useMemo, useState } from 'react';
import { WorkloadClient } from '@internal/workload-api-helper';

export const useAllowedDomains = () => {
  const [allowedDomains, setAllowedDomains] = useState<string[]>([]);
  const [loading, setLoading] = useState<boolean>(true);
  const [error, setError] = useState<string | null>(null);
  const config = useApi(configApiRef);
  const oauthApi = useApi(microsoftAuthApiRef);

  const workloadClient = useMemo(
    () => new WorkloadClient(config, oauthApi),
    [config, oauthApi],
  );

  const fetchAllowedDomains = useCallback(async () => {
    setLoading(true);
    setError(null);

    try {
      const response = await workloadClient.apiFetch(`dns-forwarders`);

      if (!response.ok) {
        throw new Error(`Response status: ${response.status}`);
      }
      const data = await response.json();
      let json_body;
      try {
        json_body = JSON.parse(data.body);
      } catch (parseError: any) {
        throw new Error(
          `Failed to parse JSON from dns-forwarders response: ${parseError.message}`,
        );
      }
      const dns_forwarder_domains = json_body.dns_forwarder_domains;
      setAllowedDomains(dns_forwarder_domains || []); // Assuming the API returns { domains: string[] }
    } catch (err: any) {
      setError(err.message);
    } finally {
      setLoading(false);
    }
  }, [workloadClient]);

  useEffect(() => {
    fetchAllowedDomains();
  }, [fetchAllowedDomains]);

  return { allowedDomains, loading, error };
};
